import { DesignProp, LayoutProp } from "../PropCategories";

export const container = {
  prop: "style-attribute",
  name: "Container maximum width",
  nameI18n: "builder_ui.prop_type.styles.container_max_width",
  category: [DesignProp, LayoutProp],
  type: "select",
  defaultValue: "none",
  options: [
    {
      label: "None",
      labelI18n: "builder_ui.prop_type.styles.container_types.none",
      value: "none",
    },
    {
      label: "Default",
      labelI18n: "builder_ui.prop_type.styles.container_types.default",
      value: "default",
    },
    {
      label: "Small",
      labelI18n: "builder_ui.prop_type.styles.container_types.sm",
      value: "640px",
    },
    {
      label: "Medium",
      labelI18n: "builder_ui.prop_type.styles.container_types.md",
      value: "768px",
    },
    {
      label: "Large",
      labelI18n: "builder_ui.prop_type.styles.container_types.lg",
      value: "1024px",
    },
    {
      label: "Extra large",
      labelI18n: "builder_ui.prop_type.styles.container_types.xl",
      value: "1280px",
    },
    {
      label: "2X large",
      labelI18n: "builder_ui.prop_type.styles.container_types.2xl",
      value: "1536px",
    },
  ],
} as const;
